/** Reserve the PDF tab during the user gesture, before an authenticated request awaits. */
export async function openPdfRequest(request, title = 'PDF wird geladen …') {
  let tab = null;
  try { tab = window.open('', '_blank'); } catch { /* Embedded browsers may forbid new tabs. */ }
  if (tab) {
    try {
      tab.document.title = title;
      tab.document.body.textContent = title;
    } catch { /* The tab can still be navigated after the response arrives. */ }
  }
  try {
    const response = await (typeof request === 'function' ? request() : request);
    const resource = response?.data?.url || response?.data || response;
    const objectUrl = typeof resource === 'string' ? null : URL.createObjectURL(resource);
    const url = objectUrl || resource;
    if (tab && !tab.closed) {
      tab.location.replace(url);
    } else {
      // A blocked new tab must still leave the PDF reachable on touch devices.
      window.location.assign(url);
    }
    if (objectUrl) window.setTimeout(() => URL.revokeObjectURL(objectUrl), 60000);
    return { response, url, opened: Boolean(tab) };
  } catch (error) {
    try { tab?.close(); } catch { /* Best effort. */ }
    throw error;
  }
}

export async function downloadPdfRequest(request, filename) {
  const appleTouch = /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (/Macintosh/.test(navigator.userAgent) && navigator.maxTouchPoints > 1);
  if (appleTouch) return openPdfRequest(request);
  const response = await (typeof request === 'function' ? request() : request);
  const url = URL.createObjectURL(response.data || response);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.setTimeout(() => URL.revokeObjectURL(url), 60000);
  return { response, url };
}
